module.exports = __webpack_public_path__ + "img/add-user.f38ca13e.svg";